export default __webpack_public_path__ + "static/media/person1.058ad906.webp";